import { UserOptionLabel, ViperSelect } from "@/components";
import { useSuggestUsersQuery } from "@/services";
import { Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";

const { Option } = Select;

interface IProps {
  onSearch: (selectedUser: string) => void;
}

export const SearchUserInput = ({ onSearch }: IProps) => {
  const intl = useIntl();
  const [query, setQuery] = useState<string>("");
  const { data: userSuggestions, isFetching: fetchingSuggestions } =
    useSuggestUsersQuery(
      { query },
      {
        skip: !query,
      }
    );

  const handleOnChange = (value: string): void => {
    onSearch(value);
  };

  return (
    <div className="w-64 flex">
      <ViperSelect
        onChange={handleOnChange}
        optionLabelProp="label"
        customOptions={userSuggestions?.map(
          ({ document: { sid, displayName, department, email, jobTitle } }) => (
            <Option key={sid} label={displayName}>
              <UserOptionLabel
                displayName={displayName}
                department={department}
                email={email}
                jobTitle={jobTitle}
              />
            </Option>
          )
        )}
        loading={fetchingSuggestions}
        onFetchSuggestions={(searchTerm): void => {
          setQuery(searchTerm);
        }}
        data-test-id="user-search-input"
        allowClear
        placeholder={intl.formatMessage({ id: "general.search" })}
      />
    </div>
  );
};
